export interface XhrUploadOptions {
  url: string;
  token: string;
  apiKey?: string;
  file: File;
  contentType?: string;
  cacheControl?: string;
  onProgress?: (fraction: number, loadedBytes: number, totalBytes: number) => void;
}

export function uploadWithXhr({
  url,
  token,
  apiKey,
  file,
  contentType = file.type || "application/octet-stream",
  cacheControl = "3600",
  onProgress,
}: XhrUploadOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    if (apiKey) {
      xhr.setRequestHeader("apikey", apiKey);
    }
    xhr.setRequestHeader("Content-Type", contentType);
    xhr.setRequestHeader("x-upsert", "false");
    if (cacheControl) {
      xhr.setRequestHeader("Cache-Control", cacheControl);
    }

    const total = file.size;
    xhr.upload.onprogress = (event: ProgressEvent) => {
      if (event.lengthComputable && total > 0) {
        const fraction = event.loaded / total;
        onProgress?.(fraction, event.loaded, total);
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        const msg = xhr.responseText || xhr.statusText || String(xhr.status);
        reject(new Error(`Upload failed (${xhr.status}): ${msg}`));
      }
    };

    xhr.onerror = () => reject(new Error(`Upload failed: network error`));
    xhr.onabort = () => reject(new Error("Upload aborted"));

    xhr.send(file);
  });
}
